import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class ImpactSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    let translationPrefix = `widgets.ai-insights.summary.${widget.payload.type}.${widget.payload.scoringStrategy}`;

    let boxSize;
    if (widget.payload.scoringStrategy === 'BOX') {
      translationPrefix = `${translationPrefix}.${widget.payload.boxDirection}`;
      boxSize = widget.payload.boxSize;
    }

    let previousFieldName;
    const getPointPrefix = (point) => {
      if (point.series.name) {
        return previousFieldName !== point.pointId ? 'first-point' : 'rest-of-points';
      }
      return !previousFieldName ? 'first-point' : 'rest-of-points';
    };

    return selectedPoints.flat().map((p) => {
      const fieldName = p.pointId;
      let translationKey = `${translationPrefix}.${getPointPrefix(p)}`;
      translationKey = `${translationKey}.${p.series.name ? 'has-comparison' : 'no-comparison'}`;

      previousFieldName = fieldName;

      return {
        translationKey,
        translationParams: {
          boxSize,
          fieldName,
          fieldValue: p.series.name,
          score: Utils.round(p.y),
        },
      };
    });
  }
}
